/**
 * German month names (1-indexed via [month - 1]).
 *
 * Shared by the invoice wizard:
 *   - Step2TenancyPeriod (period-picker labels)
 *   - Step3Items (auto-fill rent description)
 *   - Step4Preview (period summary line)
 *
 * Mirrors backend ``app/services/_locale.py::german_month`` semantically;
 * frontend keeps its own constant to avoid an extra round-trip / API call
 * for purely presentational labels.
 */
export const MONTH_NAMES_DE = [
  "Januar",
  "Februar",
  "März",
  "April",
  "Mai",
  "Juni",
  "Juli",
  "August",
  "September",
  "Oktober",
  "November",
  "Dezember",
];
